export const TERMS_OF_SERVICE_PATH = '/terms-of-service';

export const GOVERNED_COMPLIANCE_HEADING = 'COMPLIANCE & ACCREDITATIONS';
export const GOVERNED_COMPLIANCE_SUPPORTING_LINE = 'Certifications, registrations, accreditations and framework participation';

export const COMPLIANCE_PAGE_INTRO = 'Jigsaw Conferences Ltd maintains a governed record of the certifications, registrations, accreditations and framework participation supporting its services. The statuses below relate to Jigsaw Conferences Ltd as a company. They do not verify individual event listings on Jigsaw Events Hub and do not imply any affiliation with, or endorsement by, any event organiser, venue or rights holder. Individual schemes remain subject to their issuing bodies’ terms, scope and renewal requirements.';

export const COMPLIANCE_PAGE_NOTICE = 'Compliance information is reviewed periodically and updated when a certification, registration, accreditation or framework status changes. Please contact it@jigsawconferences.co.uk if you require supporting evidence or believe that any information requires correction.';

export const GOVERNED_COMPLIANCE_ITEMS = Object.freeze([
  {
    name: 'Cyber Essentials',
    status: 'CERTIFIED',
    description: 'UK Government cyber security scheme',
    category: 'cyber-security',
    evidenceUrl: null,
    lastReviewedAt: '2026-08-27',
    iconKey: 'shield',
  },
  {
    name: 'ISO 9001:2015',
    status: 'CERTIFIED',
    description: 'Quality management systems',
    certificateNumber: '6626692',
    category: 'quality-management',
    evidenceUrl: null,
    lastReviewedAt: '2026-08-27',
    iconKey: 'badge',
  },
  {
    name: 'ISO 27001:2022',
    status: 'CERTIFIED',
    description: 'Information security management',
    certificateNumber: '6501733',
    category: 'information-security',
    evidenceUrl: null,
    lastReviewedAt: '2026-08-27',
    iconKey: 'lock',
  },
  {
    name: 'ISO 14001:2015',
    status: 'CERTIFIED',
    description: 'Environmental management systems',
    certificateNumber: '9781565',
    category: 'environmental-management',
    evidenceUrl: null,
    lastReviewedAt: '2026-08-27',
    iconKey: 'leaf',
  },
  {
    name: 'SafeSupplier',
    status: 'VERIFIED',
    description: 'Supply-chain due diligence',
    category: 'supply-chain',
    evidenceUrl: null,
    lastReviewedAt: '2026-08-27',
    iconKey: 'clipboard',
  },
  {
    name: 'beam',
    status: 'APPROVED',
    description: 'Events industry code of ethics',
    category: 'industry-ethics',
    evidenceUrl: null,
    lastReviewedAt: '2026-08-27',
    iconKey: 'sparkles',
  },
  {
    name: 'ICO Registered',
    status: 'REGISTERED',
    description: 'Data Protection Act 2018 and UK GDPR',
    category: 'data-protection',
    evidenceUrl: null,
    lastReviewedAt: '2026-08-27',
    iconKey: 'file-check',
  },
  {
    name: 'ProcurePublic',
    status: 'FRAMEWORK PARTNER',
    description: 'Public-sector procurement framework',
    category: 'public-sector',
    evidenceUrl: null,
    lastReviewedAt: '2026-08-27',
    iconKey: 'building',
  },
]);